import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Heart, Smile, CloudRain, Users, Baby } from 'lucide-react';
export function AreasSection() {
  const areas = [{
    label: 'Ansiedad y estrés',
    icon: Brain
  }, {
    label: 'Autoestima y confianza',
    icon: Smile
  }, {
    label: 'Regulación emocional',
    icon: Heart
  }, {
    label: 'Duelo y transiciones',
    icon: CloudRain
  }, {
    label: 'Conflictos familiares',
    icon: Users
  }, {
    label: 'Retos en la crianza',
    icon: Baby
  }];
  return <section className="py-24 bg-gray-50" data-id="element-43">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-45">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="element-46">
            Áreas de apoyo
          </h2>
          <p className="text-lg text-gray-600" data-id="element-47">
            Temas comunes que podemos trabajar juntos.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-48">
          {areas.map((area, index) => {
          const Icon = area.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="flex items-center p-5 bg-white rounded-xl border border-gray-200" data-id="element-49">
                <div className="w-10 h-10 rounded-lg bg-teal-50 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-50">
                  <Icon className="w-5 h-5 text-teal-700" data-id="element-51" />
                </div>
                <span className="text-base font-medium text-gray-900" data-id="element-52">
                  {area.label}
                </span>
              </motion.div>;
        })}
        </div>

        <div className="mt-12 text-center" data-id="element-53">
          <p className="text-sm text-gray-500 italic" data-id="element-54">
            * Cada proceso es diferente. No prometemos resultados específicos.
          </p>
        </div>
      </div>
    </section>;
}